<div>

  <loading id="regaliaLoader" styling="pageloading-primary" [initialLoading]="true"></loading>

  @if (!pageIsLoading()) {
    <div class="pb-4">
      <div class="leading-6 font-medium">Please Note</div>
      <div class="leading-6">
        We have automatically selected the regalia items that you will require for your graduation ceremony.  If you don't require one of the items simply unselect it.
      </div>
    </div>
  }



  @for (item of (regalia$ | async); track item.institution_qualification_regalia_id) {
    @switch (item.regalia?.list_regalia_cat_id) {
      @case ('8d30a040-afeb-42f8-bd3c-cd20c34ced7f') {
        <ng-container *ngTemplateOutlet="gown; context: { regalia: item}"></ng-container>
      }
      @case ('db59b2b1-1bf5-47ea-9da9-cc3b9e103f41') {
        <ng-container *ngTemplateOutlet="hood; context: { regalia: item}"></ng-container>
      }
      @case ('cd068b87-972c-4d22-8a1c-693fe8c0d4e7') {
        <ng-container *ngTemplateOutlet="hat; context: {regalia: item}"></ng-container>
      }
      @case ('05038eca-6a7d-4e45-ae80-e235df2d0691') {
        <ng-container *ngTemplateOutlet="stole; context: {regalia: item}"></ng-container>
      }
    }
  }


  <!-- <ng-container *ngIf="isOrderLate()">
  <ng-container *ngTemplateOutlet="latefee"></ng-container>
</ng-container> -->




<!-- <ng-template #latefee>

<div class="mb-4 bg-white shadow-md rounded-2xl">
  <div  class="flex  rounded-t-2xl h-12 border-b-2 font-medium text-2xl items-center leading-6 py-3 pl-6 pr-2">
    <div class="flex-grow">Late Fee</div>
    <div class="flex-grow-0">{{ 40 | currency : resolveCurrency(null) : 'symbol' : '1.2-2' }}</div>
    <div class="flex flex-grow-0 w-16 justify-end ">
      <fa-icon  class="text-gwc-secondary-blue flex-shrink-0 text-2rem leading-8" [icon]="faCheckCircle"></fa-icon>
    </div>
  </div>
  <div class="flex rounded-b-2x p-4 font-normal items-center text-base">

    You have been charged a late fee due the order being placed after {{ graduationLateFeeDate | f3date : 'shortdate' }}

  </div>
</div>

</ng-template> -->



<ng-template #gown let-gownRegalia="regalia">

  <div class="mb-4 bg-white shadow-md rounded-2xl">
    <div  class="relative flex mobile:flex-col rounded-t-2xl mobile:rounded-t-2xl h-12 mobile:h-auto border-b-2 font-medium text-2xl items-center mobile:items-start leading-6 py-3 mobile:py-2 pl-6 pr-2 mobile:pr-14 gap-2 mobile:gap-1">
      <div class="flex-grow mobile:flex-grow-0">{{ gownRegalia.regalia.name }}</div>
      <div class="flex-grow-0 mobile:order-3 mobile:w-full mobile:flex mobile:justify-between mobile:items-center">{{ gownRegalia.price | currency : resolveCurrency(gownRegalia) : 'symbol' : '1.2-2' }}</div>
      <div class="flex flex-grow-0 w-16 mobile:w-10 mobile:h-10 mobile:order-3 justify-end mobile:justify-center mobile:items-center cursor-pointer mobile:absolute mobile:right-2 mobile:top-2"
        role="button"
        tabindex="0"
        [attr.aria-label]="isRegaliaSelected(gownRegalia) ? 'Deselect ' + gownRegalia.regalia.name : 'Select ' + gownRegalia.regalia.name"
        (click)="toggleSelectedRegalia(gownRegalia)"
        (keydown.enter)="toggleSelectedRegalia(gownRegalia)"
        (keydown.space)="toggleSelectedRegalia(gownRegalia); $event.preventDefault()">
        @if (isRegaliaSelected(gownRegalia)) {
          <fa-icon
            class="text-gwc-secondary-blue flex-shrink-0 text-3xl leading-8"
            [icon]="['fas', 'check-circle']">
          </fa-icon>
        }
        @if (!isRegaliaSelected(gownRegalia)) {
          <fa-icon
            class="text-red-500 flex-shrink-0 text-3xl leading-8"
            [icon]="['fas', 'times-circle']">
          </fa-icon>
        }
      </div>
    </div>
    <div class="flex mobile:flex-col rounded-b-2x font-medium items-center mobile:items-start text-base px-2 mobile:px-4">

      <div class="w-40 h-40 mobile:w-32 mobile:h-32 rounded-bl-2xl mobile:rounded-none flex items-center">
        <img src="{{ imageBaseUrl }}/assets/images/regalia/{{ gownRegalia.regalia.list_regalia_cat_id }}/{{ gownRegalia.regalia_id }}.png" />
      </div>

      <div class="h-40 mobile:h-auto px-4 mobile:px-0 w-full flex-col flex justify-center">
        <div>Enter your <strong>full</strong> height in <strong>centimetres.</strong> We will select the gown closest to this measurement.</div>
        <div>
          <div>
            <mat-form-field appearance="outline" (click)="$event.stopPropagation()">
              <input
                min="1"
                max="400"
                matInput
                type="number"
                [formControl]="gownHeight"
                (keydown)="preventNegative($event)"
                (keyup.enter)="blurInput($event)"
                (change)="gownHeightSelected(gownRegalia.institution_qualification_regalia_id)">
              <!-- <mat-label>Enter your height in cm</mat-label> -->
            </mat-form-field>

          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #hood let-hoodRegalia="regalia">
  <div class="mb-4 bg-white shadow-md rounded-2xl">
    <div  class="relative flex mobile:flex-col rounded-t-2xl mobile:rounded-t-2xl h-12 mobile:h-auto font-medium text-2xl items-center mobile:items-start border-b-2 leading-6 py-3 mobile:py-2 pl-6 pr-2 mobile:pr-14 gap-2 mobile:gap-1">
      <div class="flex-grow mobile:flex-grow-0">{{ hoodRegalia.regalia.name }}</div>
      <div class="flex-grow-0 mobile:order-3 mobile:w-full mobile:flex mobile:justify-between mobile:items-center">{{ hoodRegalia.price | currency : resolveCurrency(hoodRegalia) : 'symbol' : '1.2-2' }}</div>
      <div class="flex flex-grow-0 w-16 mobile:w-10 mobile:h-10 mobile:order-3 justify-end mobile:justify-center mobile:items-center cursor-pointer mobile:absolute mobile:right-2 mobile:top-2"
        role="button"
        tabindex="0"
        [attr.aria-label]="isRegaliaSelected(hoodRegalia) ? 'Deselect ' + hoodRegalia.regalia.name : 'Select ' + hoodRegalia.regalia.name"
        (click)="toggleSelectedRegalia(hoodRegalia)"
        (keydown.enter)="toggleSelectedRegalia(hoodRegalia)"
        (keydown.space)="toggleSelectedRegalia(hoodRegalia); $event.preventDefault()">
        @if (isRegaliaSelected(hoodRegalia)) {
          <fa-icon
            class="text-gwc-secondary-blue flex-shrink-0 text-3xl leading-8"
            [icon]="['fas', 'check-circle']">
          </fa-icon>
        }
        @if (!isRegaliaSelected(hoodRegalia)) {
          <fa-icon
            class="text-red-500 flex-shrink-0 text-3xl leading-8"
            [icon]="['fas', 'times-circle']">
          </fa-icon>
        }
      </div>
    </div>
    <div class="flex mobile:flex-col items-center mobile:items-start justify-center mobile:justify-start px-4 ">
      <div class="w-40 h-40 mobile:w-32 mobile:h-32 rounded-bl-2xl mobile:rounded-none flex items-center justify-center  ">
        <img src="{{ imageBaseUrl }}/assets/images/regalia/{{ hoodRegalia.regalia.list_regalia_cat_id }}/{{ hoodRegalia.regalia_id }}.png" class="rounded-lg" />
      </div>
      <div class="h-40 mobile:h-auto px-4 mobile:px-0 w-full flex flex-col justify-center">
        <div></div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #stole let-stoleRegalia="regalia">

  <div class="mb-4 bg-white shadow-md rounded-2xl">

    <div  class="relative flex mobile:flex-col h-12 mobile:h-auto font-medium text-2xl border-b-2 items-center mobile:items-start leading-6 py-3 mobile:py-2 pl-6 pr-2 mobile:pr-14 gap-2 mobile:gap-1">
      <div class="flex-grow mobile:flex-grow-0">{{ stoleRegalia.regalia.name }}</div>
      <div class="flex-grow-0 mobile:order-3 mobile:w-full mobile:flex mobile:justify-between mobile:items-center">{{ stoleRegalia.price | currency : resolveCurrency(stoleRegalia) : 'symbol' : '1.2-2' }}</div>
      <div class="flex flex-grow-0 w-16 mobile:w-10 mobile:h-10 mobile:order-3 justify-end mobile:justify-center mobile:items-center cursor-pointer mobile:absolute mobile:right-2 mobile:top-2"
        role="button"
        tabindex="0"
        [attr.aria-label]="isRegaliaSelected(stoleRegalia) ? 'Deselect ' + stoleRegalia.regalia.name : 'Select ' + stoleRegalia.regalia.name"
        (click)="toggleSelectedRegalia(stoleRegalia)"
        (keydown.enter)="toggleSelectedRegalia(stoleRegalia)"
        (keydown.space)="toggleSelectedRegalia(stoleRegalia); $event.preventDefault()">
        @if (isRegaliaSelected(stoleRegalia)) {
          <fa-icon
            class="text-gwc-secondary-blue flex-shrink-0 text-3xl leading-8"
            [icon]="['fas', 'check-circle']">
          </fa-icon>
        }
        @if (!isRegaliaSelected(stoleRegalia)) {
          <fa-icon
            class="text-red-500 flex-shrink-0 text-3xl leading-8"
            [icon]="['fas', 'times-circle']">
          </fa-icon>
        }
      </div>
    </div>

    <div class="flex mobile:flex-col font-medium text-base px-4 mobile:px-4">

      <div class="w-40 h-40 mobile:w-32 mobile:h-32 rounded-bl-2xl mobile:rounded-none flex items-center justify-center ">


        <img src="{{ imageBaseUrl }}/assets/images/regalia/{{ stoleRegalia.regalia.list_regalia_cat_id }}/{{ stoleRegalia.regalia_id }}.png" class="rounded-lg" />
      </div>

      <div class="h-40 mobile:h-auto px-4 mobile:px-0 w-full flex flex-col justify-center"></div>

    </div>
  </div>


</ng-template>


<ng-template #hat let-hatRegalia="regalia">

  <div class="mb-4 bg-white shadow-md rounded-2xl">

    <div  class="relative flex mobile:flex-col rounded-t-2xl mobile:rounded-t-2xl h-12 mobile:h-auto font-medium text-2xl border-b-2 items-center mobile:items-start leading-6 py-3 mobile:py-2 pl-6 pr-2 mobile:pr-14 gap-2 mobile:gap-1">
      <div class="flex-grow mobile:flex-grow-0">{{ hatRegalia.regalia.name }}</div>
      <div class="flex-grow-0 mobile:order-3 mobile:w-full mobile:flex mobile:justify-between mobile:items-center">{{ hatRegalia.price | currency : resolveCurrency(hatRegalia) : 'symbol' : '1.2-2' }}</div>
      <div class="flex flex-grow-0 w-16 mobile:w-10 mobile:h-10 mobile:order-3 justify-end mobile:justify-center mobile:items-center cursor-pointer mobile:absolute mobile:right-2 mobile:top-2"
        role="button"
        tabindex="0"
        [attr.aria-label]="isRegaliaSelected(hatRegalia) ? 'Deselect ' + hatRegalia.regalia.name : 'Select ' + hatRegalia.regalia.name"
        (click)="toggleSelectedRegalia(hatRegalia)"
        (keydown.enter)="toggleSelectedRegalia(hatRegalia)"
        (keydown.space)="toggleSelectedRegalia(hatRegalia); $event.preventDefault()">
        @if (isRegaliaSelected(hatRegalia)) {
          <fa-icon
            class="text-gwc-secondary-blue flex-shrink-0 text-3xl leading-8"
            [icon]="['fas', 'check-circle']">
          </fa-icon>
        }
        @if (!isRegaliaSelected(hatRegalia)) {
          <fa-icon
            class="text-red-500 flex-shrink-0 text-3xl leading-8"
            [icon]="['fas', 'times-circle']">
          </fa-icon>
        }
      </div>
    </div>

    <div class="flex mobile:flex-col rounded-b-2xl mobile:rounded-none font-medium text-base px-4 mobile:px-4 gap-4 mobile:gap-2">

      <div class="w-40 h-40 mobile:w-32 mobile:h-32 rounded-bl-2xl mobile:rounded-none flex justify-center items-center flex-shrink-0">
        <img src="{{ imageBaseUrl }}/assets/images/regalia/{{ hatRegalia.regalia.list_regalia_cat_id }}/{{ hatRegalia.regalia_id }}.png" />
      </div>



      <div class="h-40 mobile:h-auto px-4 mobile:px-0 flex flex-col justify-center flex-grow">
        <div class="font-medium mb-1">Your head circumference</div>
        <div>
          <mat-form-field appearance="outline" class="fuse-mat-dense fuse-mat-no-subscript w-full" (click)="$event.stopPropagation()">
            <mat-select [formControl]="headCircumference" (selectionChange)="headCircumferenceSelected(hatRegalia.institution_qualification_regalia_id)">
              <mat-option></mat-option>
              <mat-option value="49cm">49cm</mat-option>
              <mat-option value="50cm">50cm</mat-option>
              <mat-option value="51cm">51cm</mat-option>
              <mat-option value="52cm">52cm</mat-option>
              <mat-option value="53cm">53cm</mat-option>
              <mat-option value="54cm">54cm</mat-option>
              <mat-option value="55cm">55cm</mat-option>
              <mat-option value="56cm">56cm</mat-option>
              <mat-option value="57cm">57cm</mat-option>
              <mat-option value="58cm">58cm</mat-option>
              <mat-option value="59cm">59cm</mat-option>
              <mat-option value="60cm">60cm</mat-option>
              <mat-option value="61cm">61cm</mat-option>
              <mat-option value="62cm">62cm</mat-option>
              <mat-option value="63cm">63cm</mat-option>
              <mat-option value="64cm">64cm</mat-option>
              <mat-option value="65cm">65cm</mat-option>
              <mat-option value="66cm">66cm</mat-option>
              <mat-option value="67cm">67cm</mat-option>
            </mat-select>
          </mat-form-field>
          <div class="text-sm text-secondary mt-1">Only complete if someone is picking up on your behalf</div>
        </div>
      </div>


      <div class="flex mobile:flex-col items-center mobile:items-start gap-4 mobile:gap-2 ml-8 mobile:ml-0">

        <div>
          <a href="assets/documents/GWCRegaliaHire_HeadCircumferenceMeasurement.pdf" download  (click)="$event.stopPropagation()">
            <fa-icon [icon]="['fas', 'file-pdf']" class="text-4xl mobile:text-2xl"></fa-icon>
          </a>
        </div>

        <div class="ml-4 mobile:ml-0">
          <a href="assets/documents/GWCRegaliaHire_HeadCircumferenceMeasurement.pdf" download  (click)="$event.stopPropagation()">
            Download Sizing Guide
          </a>
        </div>
      </div>


    </div>
  </div>

</ng-template>




</div>
